document.querySelectorAll('.my-slider').forEach((slider) => {
  if (slider && typeof Swiper !== 'undefined') {
    new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 0,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 8,
          navigation: {
            enabled: false
          }
        },
        580: {
          slidesPerView: 3,
          spaceBetween: 8
        },
        700: {
          slidesPerView: 4,
          spaceBetween: 15
        }
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next--custom'),
        prevEl: slider.querySelector('.swiper-button-prev--custom'),
      },
    });
  } else {
    console.log('fail swiper')
  }
});